import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { computed, ref, watch } from "vue";
import DraggableSeparator from "@/components/Common/DraggableSeparator.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'FlexPanel',
    props: {
        collapsible: { type: Boolean, default: true },
        side: { default: "right" },
        minWidth: { default: 200 },
        maxWidth: { default: 800 },
        defaultWidth: { default: 300 }
    },
    setup(__props) {
        const props = __props;
        library.add(faChevronLeft, faChevronRight);
        const panelWidth = ref(props.defaultWidth);
        const root = ref(null);
        const show = ref(true);
        const showToggle = ref(false);
        const hoverToggle = ref(false);
        const isHoveringDragHandle = ref(false);
        const isDragging = ref(false);
        const hoverDraggableOrToggle = computed(() => (isHoveringDragHandle.value || hoverToggle.value) && !isDragging.value);
        const toggleLinger = 500;
        const toggleShowDelay = 600;
        let showToggleTimeout;
        watch(() => hoverDraggableOrToggle.value, (hover) => {
            clearTimeout(showToggleTimeout);
            if (hover) {
                showToggleTimeout = setTimeout(() => {
                    showToggle.value = true;
                }, toggleShowDelay);
            }
            else {
                showToggleTimeout = setTimeout(() => {
                    showToggle.value = false;
                }, toggleLinger);
            }
        });
        const sideClasses = computed(() => ({
            left: props.side === "left",
            right: props.side === "right",
        }));
        return { __sfc: true, props, panelWidth, root, show, showToggle, hoverToggle, isHoveringDragHandle, isDragging, hoverDraggableOrToggle, toggleLinger, toggleShowDelay, showToggleTimeout, sideClasses, FontAwesomeIcon, DraggableSeparator };
    }
});
